class PlannedCourse {
	id = null;
	code = null;
	note = '';
	department_id = null;
	language_id = 1;
	partner_id = null;
	max_students = null;
	min_students = null;
	start_date = null;
	end_date = null;
	office_id = null;
	course_id = null;
	exam_date = null;
	can_delete = false;
	planned_course_status_id = 1;
	planned_course_status_name = '';
	registration = 0;
	preregistration = 0;
	in_progress_start_date = null;
	students_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	teachers_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default PlannedCourse;
